var ContinuousSignal, Signal, distinct, latest, map;

Signal = require('../signal');

ContinuousSignal = require('../continuous-signal');

map = require('../methods/map');

latest = require('../methods/latest');

distinct = require('../methods/distinct');

module.exports = function(pred, first, second) {
  var chosenSignal;
  chosenSignal = map.call(distinct.call(pred), function(input) {
    if (input) {
      return first;
    } else {
      return second;
    }
  });
  return latest.call(chosenSignal).addDisposer(first.use()).addDisposer(second.use());
};
